{
  "name": "admin-portal",
  "version": "5.6.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build && node scripts/build-info.mjs && npm run sentry:sourcemaps",
    "test": "ng test --no-watch --no-progress --code-coverage",
    "test:dev": "ng test --code-coverage --karma-config=karma.conf.dev.js",
    "test:coverage": "ng test --no-watch --no-progress --browsers ChromeHeadlessNoSandbox",
    "lint": "ng lint",
    "prepare": "husky",
    "lint-staged": "lint-staged -v",
    "pre-commit": "lint-staged && ng lint",
    "lint-scss": "stylelint src/**/*.scss --fix",
    "prettier": "prettier --write src/**/*.{ts,scss}",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org rocket-financial-inc --project admin-portal-prod ./dist/admin-portal && sentry-cli sourcemaps upload --org rocket-financial-inc --project admin-portal-prod ./dist/admin-portal"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.4",
    "@angular/cdk": "^22.2.5",
    "@angular/common": "^22.2.4",
    "@angular/compiler": "^22.2.4",
    "@angular/core": "^22.2.4",
    "@angular/forms": "^22.2.4",
    "@angular/localize": "^22.2.4",
    "@angular/platform-browser": "^22.2.4",
    "@angular/platform-browser-dynamic": "^22.2.4",
    "@angular/router": "^22.2.4",
    "@babel/eslint-parser": "^7.25.1",
    "@ng-bootstrap/ng-bootstrap": "^21.0.0",
    "@ng-select/ng-select": "^23.11.0",
    "@ngrx/effects": "^21.1.1",
    "@ngrx/operators": "^21.1.1",
    "@ngrx/router-store": "^21.1.1",
    "@ngrx/store": "^21.1.1",
    "@ngrx/store-devtools": "^21.1.1",
    "@ngx-formly/core": "^6.3.6",
    "@popperjs/core": "^2.11.8",
    "@rocketfinancialcorp/rocket-ui": "^3.1.0",
    "@sentry/angular": "^11.10.0",
    "@sentry/cli": "^2.33.0",
    "@siemens/ngx-datatable": "^27.1.0",
    "@types/google.maps": "^3.55.12",
    "angular-in-memory-web-api": "^0.22.0",
    "crypto-es": "^2.1.0",
    "date-fns": "^3.6.0",
    "date-fns-tz": "^3.1.3",
    "firebase": "^10.12.4",
    "flag-icons": "^7.2.3",
    "karma-sonarqube-unit-reporter": "^0.0.23",
    "libphonenumber-js": "^1.11.5",
    "lodash-es": "^4.17.21",
    "ngrx-store-localstorage": "^20.1.0",
    "ngx-extended-pdf-viewer": "^28.1.2",
    "ngx-mask": "^22.2.5",
    "ngx-pagination": "^6.0.3",
    "ngx-toastr": "^20.0.5",
    "rxjs": "^7.8.1",
    "tslib": "^2.6.3",
    "typescript": "~6.0.3",
    "uuid": "^10.0.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^22.2.5",
    "@angular-eslint/builder": "^22.6.0",
    "@angular-eslint/eslint-plugin": "^22.6.0",
    "@angular-eslint/eslint-plugin-template": "^22.6.0",
    "@angular-eslint/schematics": "^22.6.0",
    "@angular-eslint/template-parser": "^22.6.0",
    "@angular/build": "^22.2.5",
    "@angular/cli": "^22.2.5",
    "@angular/compiler-cli": "^22.2.4",
    "@eslint/js": "^9.39.5",
    "@types/jasmine": "~5.1.4",
    "@types/lodash-es": "^4.17.12",
    "@types/node": "^20.14.8",
    "@types/uuid": "^10.0.0",
    "@typescript-eslint/eslint-plugin": "^8.72.1",
    "@typescript-eslint/parser": "^8.72.1",
    "angular-eslint": "^22.6.0",
    "autoprefixer": "^10.4.19",
    "eslint": "^9.39.5",
    "husky": "^9.1.4",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~5.2.0",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "karma-spec-reporter": "0.0.36",
    "karma-verbose-reporter": "^0.0.8",
    "lint-staged": "^15.2.7",
    "postcss": "^8.4.40",
    "postcss-scss": "^4.0.9",
    "prettier": "^3.3.3",
    "stylelint": "^16.8.1",
    "stylelint-config-prettier": "^9.0.5",
    "stylelint-config-standard": "^36.0.1",
    "stylelint-declaration-strict-value": "^1.10.6",
    "stylelint-prettier": "^5.0.2",
    "stylelint-scss": "^6.4.1",
    "tailwindcss": "^3.4.7",
    "ts-node": "~10.9.2",
    "typescript-eslint": "^8.72.1"
  },
  "browser": {
    "crypto": false
  },
  "lint-staged": {
    "**/*.{json,md,html}": [
      "prettier --write"
    ],
    "**/*.ts": [
      "prettier --write",
      "eslint"
    ],
    "**/*.scss": [
      "prettier --write",
      "npm run lint-scss"
    ]
  }
}
